@if (isLoading$ | async) {
  <div class="loader">
    <app-loader></app-loader>
  </div>
}
<div mat-dialog-title>
  <h2>
    {{ 'changePassword.title' | translate }}
  </h2>
  <div class="dialog__buttons">
    <button
      type="submit"
      class="primary-button"
      [disabled]="formGroup.invalid"
      (click)="changePassword()"
      data-test="change-password">
      {{ 'shared.save' | translate }}
    </button>
  </div>
</div>
<mat-dialog-content>
  <form [formGroup]="formGroup">
    <mat-form-field>
      <mat-label>{{ 'changePassword.newPassword' | translate }}</mat-label>
      <input matInput
             formControlName="newPassword"
             type="password"
             autocomplete="new-password">
      @if (formGroup.get('newPassword')?.invalid && formGroup.get('newPassword')?.touched) {
        <mat-error>
          @if (formGroup.get('newPassword')?.hasError('required')) {
            {{ 'changePassword.errorRequired' | translate }}
          } @else if (formGroup.get('newPassword')?.hasError('minlength')) {
            {{ 'changePassword.minLength' | translate }}
          }
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'changePassword.confirmNewPassword' | translate }}</mat-label>
      <input matInput
             formControlName="repeatPassword"
             type="password"
             autocomplete="new-password">
      @if (formGroup.get('repeatPassword')?.invalid && formGroup.get('repeatPassword')?.touched) {
        <mat-error>
          @if (formGroup.get('repeatPassword')?.hasError('required')) {
            {{ 'changePassword.errorRequired' | translate }}
          } @else if (formGroup.get('repeatPassword')?.hasError('passwordsMismatch')) {
            {{ 'changePassword.mismatch' | translate }}
          }
        </mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
